export default __webpack_public_path__ + "static/media/type-video.a455b492.jpg";